import "./index.css";
import General from "./components/General/General";
import React, { useState } from "react";
import Preview from "./components/Preview/Preview";
import Header from "../src/components/Header/Header";
import Footer from "../src/components/Footer/Footer";

function App() {
  const [preview, setPreview] = useState(false);
  const [copy, setCopy] = useState("1");
  const [hideBtn, setHideBtn] = useState(false);

  const handlePreviewButton = () => {
    setPreview(!preview);
  };

  const handlePrintButton = () => {
    setHideBtn(true);
    setTimeout(() => {
      window.print();
    }, 250);
  };

  const handleCopyButton = (copies) => {
    setCopy(copies);
  };

  return (
    <div className="App">
      {!preview && <Header />}
      {!hideBtn ? (
        <div className="row">
          <div className="col-4">
            {!preview ? (
              <button
                type="button"
                className="btn btn-primary m-2"
                onClick={() => handlePreviewButton()}
              >
                Print Preview
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary m-2"
                onClick={() => handlePrintButton()}
              >
                Print
              </button>
            )}
          </div>
          <div className="col-4">
            <button type="button" className="btn btn-secondary m-2">
              Download
            </button>
          </div>
          <div className="col-4">
            <button type="button" className="btn btn-success m-2 disabled">
              Whatsapp
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}

      {preview ? (
        <div className="container">
          <div className="row align-items-start">
            <div className="col-12">
              {!hideBtn ? (
                <div className="row">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary m-2"
                      onClick={() => {
                        handleCopyButton("1");
                      }}
                    >
                      One Copy
                    </button>
                  </div>
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-primary m-2"
                      onClick={() => {
                        handleCopyButton("2");
                      }}
                    >
                      Two Copy
                    </button>
                  </div>
                </div>
              ) : (
                <></>
              )}

              <Preview />
              {copy === "2" ? <Preview /> : <></>}
            </div>
          </div>
        </div>
      ) : (
        <General />
      )}
      {!preview && <Footer />}
    </div>
  );
}

export default App;
